import BaseService from './base.service'

class FeedbackService extends BaseService {
    getQuestions() {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Feedback.getQuestions',
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }

    sendAnswers(params) {
        return new Promise((resolve, reject) => {
            return this.request()
                .post({
                    method: 'Feedback.sendAnswers',
                    params,
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(this.errorWrapper(error.response))
                })
        })
    }
}

export default new FeedbackService()
